<main class="flex relative min-h-screen w-full flex-col bg-white">
  @if (isHomePage()) {
    <app-popup-banner />
  }
  <app-floating-buttons
    class="fixed bottom-18 right-3 lg:bottom-6 lg:right-6 z-40 transition-opacity"
    [class.hidden]="isFloatingHiddenPage() && isMobileSize()" />

  <div class="mx-auto w-full flex-1 flex flex-col">
    @if (eventPopupVisible() && upcomingEvent() && isHomePage()) {
    <div @slideDown class="bg-black text-zinc-800 fixed top-0 w-full z-1000">
      <div class="relative container mx-auto py-4 w-full px-4">
        <div class="hidden md:flex items-center justify-between w-full">
          <div class="flex justify-between w-full items-end">
            <div class="flex flex-col gap-2">
              <div class="flex items-center gap-2 flex-1">
                <img src="/home/calendar.svg" alt="calendar icon" class="size-7" />
                <div class="flex items-center">
                  <app-icon name="material-symbols:arrow-back-2-rounded" class="size-5! text-[#FAE5C7]" />
                  <span class="text-primary-500 bg-[#FAE5C7] px-3 py-1 rounded-md sb-aggro text-sm -ml-2">
                    Coming up!
                  </span>
                </div>
              </div>
              <p class="flex-1 sb-aggro font-light text-2xl text-white">
                {{ upcomingEvent()?.title }}
                <span class="sb-aggro font-normal">사전등록 진행중</span>
              </p>
            </div>

            <div class="flex gap-6 items-center pr-20">
              <div class="relative flex items-center justify-center">
                <img src="/home/deco.svg" alt="deco image" class="animate-pulse" />
                @if (dDay()) {
                <span class="absolute text-white text-4xl sb-aggro text-dday-shadow">
                  {{ dDay() }}
                </span>
                }
              </div>

              <button
                [routerLink]="['/event', upcomingEvent()?.id]"
                class="cursor-pointer text-sm flex items-center gap-1 bg-zinc-800 text-white px-3 py-2 rounded-full sb-aggro font-light whitespace-nowrap shrink-0">
                상세보기
                <app-icon name="material-symbols:arrow-outward-rounded" class="size-5! text-white" />
              </button>
            </div>
          </div>
        </div>

        <div class="flex md:hidden flex-col gap-3">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <img src="/home/calendar.svg" alt="calendar icon" class="size-6" />
              <div class="flex items-center">
                <app-icon name="material-symbols:arrow-back-2-rounded" class="size-4! text-[#FAE5C7]" />
                <span class="text-primary-500 bg-[#FAE5C7] px-2 py-0.5 rounded-md sb-aggro text-xs -ml-1.5">
                  Coming up!
                </span>
              </div>
            </div>

            <button
              type="button"
              (click)="closeEventPopup()"
              class="text-zinc-800 flex items-center cursor-pointer"
              aria-label="팝업 닫기">
              <app-icon name="material-symbols:close-rounded" class="size-5! text-zinc-300" />
            </button>
          </div>

          <p class="sb-aggro font-light text-sm text-white">
            {{ upcomingEvent()?.title }}
            <span class="sb-aggro font-normal">사전등록 진행중</span>
          </p>

          <div class="flex items-center justify-between gap-3">
            <div class="relative flex items-center justify-center">
              <img src="/home/deco.svg" alt="deco image" class="animate-pulse w-20" />
              @if (dDay()) {
              <span class="absolute text-white text-2xl sb-aggro text-dday-shadow">
                {{ dDay() }}
              </span>
              }
            </div>

            <button
              [routerLink]="['/event', upcomingEvent()?.id]"
              class="cursor-pointer text-xs flex items-center gap-1 bg-zinc-800 text-white px-3 py-2 rounded-full sb-aggro font-light whitespace-nowrap shrink-0">
              상세보기
              <app-icon name="material-symbols:arrow-outward-rounded" class="size-4! text-white" />
            </button>
          </div>
        </div>

        <button
          type="button"
          (click)="closeEventPopup()"
          class="hidden md:flex absolute top-4 right-2 text-zinc-800 items-center cursor-pointer"
          aria-label="팝업 닫기">
          <app-icon name="material-symbols:close-rounded" class="size-6! text-zinc-300" />
        </button>
      </div>
    </div>
    }

    <app-header (menuToggle)="toggleMenu()" />
    <div class="flex-1">
      <router-outlet />
    </div>

    @if (menuOpen()) {
    <div @slideInOut class="bg-white fixed top-0 z-50 h-screen w-full overflow-y-auto px-4 pb-20 lg:hidden">
      <div class="flex justify-between items-center py-3 pb-6">
        <a routerLink="/" (click)="toggleMenu()" class="cursor-pointer flex items-center h-12">
          <img
            [src]="logoData()?.value || '/logo.svg'"
            alt="밀리언쇼 로고"
            class="bg-cover bg-center bg-no-repeat w-16" />
        </a>
        <button type="button" (click)="toggleMenu()" class="cursor-pointer text-zinc-400" aria-label="close menu">
          <app-icon name="material-symbols:close" class="size-6!" />
        </button>
      </div>

      <nav class="flex flex-col text-zinc-800">
        @for (item of navItems; track $index) {
        <a
          [routerLink]="[item.path]"
          (click)="toggleMenu()"
          class="flex justify-between items-center cursor-pointer py-4 border-b border-zinc-100">
          <span class="text-base font-semibold text-zinc-800">{{ item.label }}</span>
          <app-icon name="material-symbols:arrow-forward-ios-rounded" class="size-4! text-zinc-300" />
        </a>
        }

        <div class="flex gap-3 w-full pt-6">
          <button
            class="cursor-pointer flex-1 flex items-center justify-center gap-2 rounded-xl font-semibold py-3.5 bg-primary-500 text-white shadow-custom"
            routerLink="/registration-form"
            (click)="toggleMenu()">
            <app-icon name="material-symbols:arrow-outward-rounded" class="size-5!" />
            사전 등록
          </button>
          <button
            routerLink="/booth-application-form"
            (click)="toggleMenu()"
            class="cursor-pointer flex-1 flex items-center justify-center gap-2 rounded-xl font-semibold py-3.5 border border-zinc-200 text-zinc-700">
            <app-icon name="mdi:file-document-edit-outline" class="size-5! text-zinc-500" />
            참가 신청
          </button>
        </div>

        <div class="flex flex-col mt-8">
          <div class="flex items-center gap-2 pb-3">
            <span class="text-xs font-semibold text-zinc-400 uppercase tracking-widest">연계사이트</span>
            <div class="flex-1 h-px bg-zinc-100"></div>
          </div>
          @for (site of relatedSites; track $index) {
          <a
            [href]="site.url"
            target="_blank"
            rel="noopener noreferrer"
            (click)="toggleMenu()"
            class="flex justify-between items-center py-2.5">
            <span class="text-sm text-zinc-400 font-medium">{{ site.label }}</span>
            <app-icon name="material-symbols:arrow-forward-ios-rounded" class="size-3! text-zinc-200" />
          </a>
          }
        </div>
      </nav>
    </div>
    }
  </div>

  <div
    class="fixed bottom-0 left-0 w-full z-40 lg:hidden"
    [class.hidden]="menuOpen() || (isFloatingHiddenPage() && isMobileSize())">
    <a
      routerLink="/registration-form"
      class="bg-primary-500 hover:bg-primary-700 transition-colors flex items-center justify-center gap-2 w-full h-15 cursor-pointer shadow-[0_-4px_10px_rgba(0,0,0,0.1)]">
      <app-icon name="mdi:dots-grid" class="size-6! text-white" />
      <span class="sb-aggro text-lg text-white">사전등록하러가기</span>
    </a>
  </div>

  <div class="pb-15 lg:pb-0">
    <app-footer />
  </div>
</main>
